<div class="side-mid">
  <div class="sidemenu">
    <!-- Closed Left Nav-->
    @if (!(menuController.isOpen("menu") | async)) {
      <span>
        @if (authService.allowDrawerToggle()) {
          @for (value of CLOSED_VALUES; track value) {
            @if (
              roleUtils.showScreen(
                value.route,
                userRole,
                currentLocation?.location,
                sciIndicator
              )
            ) {
              @switch (value.iconType) {
                @case (TYPE.DISPLAY_ONLY) {
                  <app-display-only-icon
                    [icon]="value.icon"
                    [route]="value.route"
                    (emitClick)="toggleDrawer()"
                  />
                }
                @case (TYPE.ROUTE) {
                  <app-nav-icon [icon]="value.icon" [route]="value.route" />
                }
              }
            }
          }
        }
      </span>
    }

    <!-- Opened Left Nav-->
    <ion-menu menuId="menu" contentId="main-menu" #drawer>
      <ion-content class="sidemenu2">
        <div class="opened-container">
          @for (value of OPEN_VALUES; track value) {
            @if (
              roleUtils.showScreen(
                value.route,
                userRole,
                currentLocation?.location,
                sciIndicator
              )
            ) {
              <span>
                @switch (value.iconType) {
                  @case (TYPE.ROUTE) {
                    <app-nav-icon
                      [displayText]="value.displayText"
                      [hasDisplayText]="true"
                      [icon]="value.icon"
                      [route]="value.route"
                    />
                  }
                  @case (TYPE.SUB_ROUTE) {
                    <app-sublink-icon
                      [displayText]="value.displayText"
                      [route]="value.route"
                    />
                  }
                  @case (TYPE.DISPLAY_ONLY) {
                    <app-display-only-icon
                      [displayText]="value.displayText"
                      [hasDisplayText]="true"
                      [icon]="value.icon"
                      [route]="value.route"
                    />
                  }
                }
              </span>
            }
          }
        </div>
      </ion-content>
    </ion-menu>

    <div
      id="main-menu"
      slot="content"
      [class]="{
        'nav-open': (this.menuController.isOpen('menu') | async),
      }"
    >
      <ng-content />
    </div>
  </div>
</div>
